'use client'

import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { useMemo } from 'react'

dayjs.extend(relativeTime)

export interface RelativeTimeProps {
  date: dayjs.ConfigType
  from?: dayjs.ConfigType
  fromNow?: boolean
  to?: dayjs.ConfigType
  toNow?: boolean
  withoutSuffix?: boolean
}

const RelativeTime = function RelativeTime(props: RelativeTimeProps) {
  const { date, from, fromNow, to, toNow, withoutSuffix } = props

  const child = useMemo(() => {
    if (from) {
      return dayjs(date).from(from, withoutSuffix)
    }

    if (fromNow) {
      return dayjs(date).fromNow(withoutSuffix)
    }

    if (to) {
      return dayjs(date).to(to, withoutSuffix)
    }

    if (toNow) {
      return dayjs(date).toNow(withoutSuffix)
    }
  }, [date, from, fromNow, to, toNow, withoutSuffix])

  return <>{child}</>
}

export default RelativeTime
